import './UserAssessmentModal.scss'

import { Button, Card, Col, Modal, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import Drawer from 'react-bottom-drawer'

import { ROUTE_ASSESSMENT } from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { useState } from 'react'

/**
 * User Assessment Modal component: used to display a CTA that triggers a modal or bottom drawer
 * to get the user to retake an assessment.
 * @param {string} className - The class name to apply to the component
 * @param {string} variant - The variant of the component to display. Can be 'card' or 'link'
 */
export default function UserAssessmentModal({
  className = '',
  variant = 'card',
  linkText = 'Take assessment'
}) {
  const history = useHistory()
  const isLargeScreen = useMediaQuery({ minWidth: 768 })
  const [showModal, setShowModal] = useState(false)
  const [showDrawer, setShowDrawer] = useState(false)

  const modalContent = (
    <>
      <p>
        We provide two ways to reach your relationship, mental health, and
        self-improvement goals:
      </p>
      <ul>
        <li>Explore Remble on your own or</li>

        <li>Let us guide you based on what you need and what you like</li>
      </ul>
      <p>
        Personalizing takes only a few minutes and you can complete it at any
        time.
      </p>
    </>
  )

  const modalButtons = (
    <>
      <Button
        variant='link'
        onClick={_ => {
          setShowModal(false)
          setShowDrawer(false)
        }}
      >
        Cancel
      </Button>

      <Button
        variant='primary'
        className='px-4'
        onClick={_ => navigateTo(ROUTE_ASSESSMENT, history)}
      >
        Begin assessment
      </Button>
    </>
  )

  return (
    <>
      {/* If we have children, render them instead of the card */}
      {variant === 'link' ? (
        <Button
          variant='link'
          onClick={_ =>
            isLargeScreen ? setShowModal(true) : setShowDrawer(true)
          }
          className={`text-decoration-none green assessment-link ${className}`}
        >
          {linkText}
        </Button>
      ) : (
        <div className={`user-assessment-modal ${className}`}>
          <Card className='text-center'>
            <Card.Body>
              <Card.Title>Let’s help you succeed</Card.Title>
              <Card.Text as='div'>
                <p>
                  Tell us more about you so that we can provide better
                  recommendations
                </p>
                <div className='d-flex justify-content-center my-3'>
                  <Button
                    variant='primary'
                    onClick={_ =>
                      isLargeScreen ? setShowModal(true) : setShowDrawer(true)
                    }
                  >
                    Begin assessment
                  </Button>
                </div>
                <span className='muted small'>
                  We know things change, so you can update this anytime in your
                  profile
                </span>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      )}

      <Drawer
        duration={250}
        hideScrollbars={true}
        isVisible={showDrawer}
        className='user-assessment-modal__drawer pb-5'
        onClose={_ => setShowDrawer(false)}
      >
        <Row className='pb-4'>
          <Col xs={12} className='px-4'>
            <h3 className='mt-3'>Personalize Remble for you!</h3>
            {modalContent}
          </Col>
          <Col xs={12} className='mt-4 mb-5 text-end px-4'>
            {modalButtons}
          </Col>
        </Row>
      </Drawer>

      <Modal
        title='Personalization'
        show={showModal}
        onClose={_ => setShowModal(false)}
        className='user-assessment-modal__modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>Personalize Remble for you!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalContent}</Modal.Body>
        <Modal.Footer>{modalButtons}</Modal.Footer>
      </Modal>
    </>
  )
}
